import { render, staticRenderFns } from "./AcceptItems.vue?vue&type=template&id=871aa344"
import script from "./AcceptItems.vue?vue&type=script&lang=js"
export * from "./AcceptItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports